import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {ErrorComponent} from './error/error.component';
import {ApiService} from "./service/api.service";
import {HttpClientModule} from "@angular/common/http";
import {LoggerService} from "./service/logger.service";
import {OauthModule} from "./oauth/oauth.module";
import {Lr3Service} from "./service/lr3.service";
@NgModule({
  declarations: [
    AppComponent,
    ErrorComponent
  ],
  imports: [
    OauthModule,
    HttpClientModule,
    BrowserModule,
    AppRoutingModule
  ],
  providers: [
    LoggerService,
    ApiService,
    Lr3Service
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
